import React from "react";
import { FieldErrors, FieldValues } from "react-hook-form";

  const getFormErrorMessage = (name: keyof FieldValues, errors: FieldErrors<FieldValues>) => {
    return errors[name] ? <small className="p-error">{errors[name]?.message as string}</small> : <small className="p-error">&nbsp;</small>;
  }

  // eslint-disable-next-line import/prefer-default-export
  export { getFormErrorMessage }